$(document).ready(function() {
  
    // =========================================
    // SET VALUES
    // =========================================
    var originalPrice = parseFloat($('#original-price').val()) || 0;
    var addonOriginalPrice = parseFloat($('#addon-prices').val()) || 0;
    var compareAtPrice = parseFloat($('#original-compare-at-price').val()) || 0;
    var totalPrice = originalPrice;
    var addOnPrice = addonOriginalPrice;
    var currentCurrency = $('#current-currency').val();
    
    // =========================================
    // TEMPLATING
    // =========================================
    function setColumnWidths() {
      $('.sbly-nl--section .sbly-nl--row').each(function() {
        var $row = $(this);
        var $cols = $row.children('.sbly-nl--col');
        var windowWidth = $(window).width();
    
        $cols.each(function() {
          var $col = $(this);
          var colClass = $col.attr('class').split(' ').find(cls => cls.startsWith('sbly-nl--col-'));
    
          if (windowWidth <= 768) { // Mobile screen
            $col.css('width', '100%');
          } else {
            if (colClass) {
              var colValue = colClass.split('-').pop();
              var colWidth = colValue.match(/^\d+$/) ? colValue + '%' : '50%';
              $col.css('width', colWidth);
            } else {
              var colCount = $cols.length;
              var colWidth = colCount > 0 ? (100 / colCount) + '%' : '100%';
              $col.css('width', colWidth);
            }
          }
        });
      });
    }
    
    setColumnWidths();
    
    // Reapply column widths on window resize
    $(window).resize(setColumnWidths);
  
    // =========================================
    // PRODUCT PAGE: AUTO HTML FORMATTING LEFT AND RIGHT
    // =========================================
    $(window).on('load', function() {
      // Create the main container if it doesn't exist
      if ($('.sbly-template').length === 0) {
        $('body').append('<div class="sbly-template hidden" id="sbly-template"><div class="sbly-nl-container"></div></div>');
      }
  
      var $container = $('.sbly-nl-container');
  
      // Check if the container exists
      if ($container.length > 0) {
        // Find all .shopify-section elements containing .sbly-nl--left or .sbly-nl--right
        $('.shopify-section').each(function() {
          var $left = $(this).find('.sbly-nl--left');
          var $right = $(this).find('.sbly-nl--right');
  
          if ($left.length) {
            // Move the .sbly-nl--left element to the container
            $left.appendTo($container);
          }
  
          if ($right.length) {
            // Move the .sbly-nl--right element to the container
            $right.appendTo($container);
          }
  
          // Remove the empty .shopify-section if it contains only .sbly-nl--left or .sbly-nl--right
          if ($left.length || $right.length) {
            $(this).remove();
          }
        });
  
        // Fade in the elements after formatting is done
        $container.find('.sbly-template, .sbly-nl--left, .sbly-nl--right').fadeIn(1000).removeClass('hidden');
        $('.sbly-nl--preload-section').remove();
      }
    });
    
    // =========================================
    // PRODUCT VARIANT: DROPDOWN
    // =========================================
    // Initialize first button as active for dropdowns and buttons
    $('.sbly-nl-variation-selection .sbly-nl-dropdown').each(function() {
        var $dropdown = $(this);
        var $queenButton = $dropdown.find('button[data-option-value*="Queen"]');  // Find the "Queen" option

        if ($queenButton.length) {
            // Remove active class from any other buttons
            $dropdown.find('button.active').removeClass('active').css('display', 'none');

            // Set the "Queen" button as active and display it
            $queenButton.addClass('active').css('display', 'flex');
        } else {
            // If no "Queen" button is found, set the first button as active
            $dropdown.find('button').first().addClass('active').css('display', 'flex');
        }
    });

    // =========================================
    // PRODUCT VARIANT: RADIO BUTTONS (Hidden)
    // =========================================
    function checkQueenRadioButton() {
        // Find the hidden radio input where the data-option-1 contains "Queen"
        var $queenRadio = $('.variant input[type="radio"]').filter(function() {
            return $(this).data('option-1').includes("Queen");
        });
    
        if ($queenRadio.length) {
            // Uncheck all other radio buttons and check the Queen one
            $('.variant input[type="radio"]').prop('checked', false);
            $queenRadio.prop('checked', true);
            console.log('queen');
        } else {
            console.log('noqueen');
        }
    }

    // Call the function to make Queen the default
    setTimeout(function() {
        checkQueenRadioButton();  // Make Queen the default
    }, 100);  // Adjust the delay as necessary
    
    // Handle clicks on dropdown buttons
    $('.sbly-nl-variation-selection .sbly-nl-dropdown').on('click', 'button', function() {
        var $button = $(this);
        var $selection = $button.closest('.sbly-nl-variation-selection .sbly-nl-dropdown');
        var $buttons = $selection.find('button');

        if ($button.hasClass('active')) {
            $buttons.css('display', 'flex');
        } else {
            $buttons.removeClass('active').css('display', 'none');
            $button.addClass('active').css('display', 'flex');
        }

        updateHiddenOptionsAndCheckVariant();
    });

    // Call update on page load
    updateHiddenOptionsAndCheckVariant();
    
    // Handle clicks on button variations
    $('.sbly-nl-variation-selection .sbly-nl-button').on('click', 'button', function() {
      var $button = $(this);
      var $selection = $button.closest('.sbly-nl-variation-selection .sbly-nl-button');
      var $buttons = $selection.find('button');
    
      if (!$button.hasClass('active')) {
        $buttons.removeClass('active');
        $button.addClass('active');
      }
    
      updateHiddenOptionsAndCheckVariant();
    });
    
    // =========================================
    // PRODUCT VARIANT: FUNCTIONS
    // =========================================
    function updateHiddenOptionsAndCheckVariant() {
        // Update hidden input values
        $('.sbly-nl-variation-selection .sbly-nl-dropdown button.active, .sbly-nl-variation-selection .sbly-nl-button button.active').each(function() {
            var optionName = $(this).data('option-name');
            var optionValue = $(this).data('option-value');
            var optionPosition = $(this).closest('.sbly-nl-variation-selection').find('.sbly-nl-dropdown, .sbly-nl-button').attr('id').split('-')[1];

            $('#hidden-option-' + optionPosition).val(optionValue);
        });

        // Find and check the corresponding variant radio button
        var selectedOptions = {};
        $('.sbly-nl-variation-selection .sbly-nl-dropdown button.active, .sbly-nl-variation-selection .sbly-nl-button button.active').each(function() {
            var optionName = $(this).data('option-name');
            var optionValue = $(this).data('option-value');
            selectedOptions['option-' + $(this).closest('.sbly-nl-variation-selection').find('.sbly-nl-dropdown, .sbly-nl-button').attr('id').split('-')[1]] = optionValue;
        });

        var matchedVariant = null;
        $('.variant input[type="radio"]').each(function() {
            var match = true;
            for (var option in selectedOptions) {
                if ($(this).data(option) != selectedOptions[option]) {
                    match = false;
                    break;
                }
            }

            if (match) {
                $(this).prop('checked', true);
                matchedVariant = $(this);
            }
        });

        if (matchedVariant) {
            var price = matchedVariant.data('price');
            var compare_price = matchedVariant.data('compare-price');
            $('#original-price').val(price);
            updateCartPrice(price);
            updatePrices(compare_price);
            updateDiscountPrices(price, compare_price);

            // Call the function to update the addon dropdowns
            updateAddonDropdowns(selectedOptions['option-1']);
            resetAddons();
        }
    }

    function resetAddons() {
        // Uncheck all addon buttons
        $('.sbly-nl--quick-add-btn').removeClass('btn-added');
        $('.sbly-nl--quick-add-btn .action-check').hide();
        $('.sbly-nl--quick-add-btn .action-add').show();

        // Clear the addon variants list
        $('#addon-variants').val('');

        // Reset addon prices
        $('#addon-prices').val(0);

        // Update cart price to base price
        var basePrice = parseFloat($('#original-price').val()) || 0;
        updateCartPrice(basePrice);
    }

    function formatMoney(amount) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }
        
    function updatePayLaterPrice(price) {
        var payLaterPrice = Math.round((price / 100) / 12);
        $('.sbly-nl--pay-later-price .amount').text(payLaterPrice);
    }
    
    function updateCartPrice(price) {
        var formattedPrice = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(price / 100);
        $('h2.sbly-nl--cart-price .amount').text(formattedPrice);
        $('.product-info .price .money').text(formattedPrice);
    
        // Call the function to update the pay-later price
        updatePayLaterPrice(price);
    }
    // Initial check on page load
    updateHiddenOptionsAndCheckVariant();

    // =========================================
    // Update Prices
    // =========================================
    function updatePrices(price) {
        var formattedPrice = formatMoney(price / 100);
        $('.sbly-nl--txt-xsmall.discount .money').text(currentCurrency + '' + formattedPrice);
        $('.sbly-nl--prices.sbly-nl--txt-small .discount .money').text(currentCurrency + '' + formattedPrice);
    }

    function updateDiscountPrices(price, compare_price) {
        var formattedDiscount = formatMoney((compare_price - price) / 100);
        $('#sbly-nl--total-discounted-price .money').text(currentCurrency + '' + formattedDiscount);
    }

    // Event listener for variant changes
    $('.sbly-nl-variation-selection .sbly-nl-dropdown button, .sbly-nl-variation-selection .sbly-nl-button button').on('click', function() {
        updateHiddenOptionsAndCheckVariant();
    });

    // Function to update addon dropdowns based on selected size
    function updateAddonDropdowns(selectedSize) {
        $('select.product-variations').each(function() {
            var $select = $(this);
            var found = false;
            $select.find('option').each(function() {
                if ((selectedSize === "Cal King" && ($(this).text().includes("Cal King") || $(this).text().includes("California King"))) ||
                    (selectedSize === "California King" && ($(this).text().includes("California King") || $(this).text().includes("Cal King"))) ||
                    $(this).text().includes(selectedSize)) {
                    $(this).prop('selected', true).trigger('change');
                    found = true; // Stop after the first match
                    updateAddonValues($(this));
                    return false; // Break the loop
                }
            });
            if (!found) {
                // If no matching option found, hide the quick add button
                var productHandle = $select.attr('id').replace('-variations', '');
                var cleanProductHandle = productHandle.replace('-addons', '');
                var $addon = $('[data-product-handle="' + cleanProductHandle + '-addons"]');
                $addon.find('.sbly-nl--quick-add-btn').hide();
            }
        });
    }

    function updateAddonValues($selectedOption) {
        var productHandle = $selectedOption.closest('select').attr('id').replace('-variations', '');
        var variantPrice = $selectedOption.data('price');
        var compareAtPrice = $selectedOption.data('compare-at-price');
        var variantId = $selectedOption.val();
        var variantSize = $selectedOption.data('variation');
    
        // Remove the "-addons" suffix
        var cleanProductHandle = productHandle.replace('-addons', '');
    
        var $addon = $('[data-product-handle="' + cleanProductHandle + '-addons"]');
    
        $addon.find('.sbly-nl--quick-add-btn')
            .attr('data-price', variantPrice)
            .attr('data-compare-at-price', compareAtPrice)
            .attr('data-variant-id', variantId)
            .attr('data-variant-size', variantSize);
    
        $addon.find('.discount .money').text(currentCurrency + (variantPrice / 100).toFixed(2));
    
        var $priceSaved = $addon.find('.price.price-saved');
        if (compareAtPrice === "null" || compareAtPrice === null) {
            $priceSaved.hide();
        } else {
            $priceSaved.show().find('.money').text(currentCurrency + (compareAtPrice / 100).toFixed(2));
        }
    
        var $productName = $addon.find('.addon-product .product-name');
        $productName.find('.variation').remove(); // Remove existing variation span if any
        $productName.append('<span class="variation"> - ' + variantSize + '</span>');
    
        // Check if the variant is available
        var jsonData = $(`#${productHandle}_data`).text().trim();
        if (jsonData) {
            try {
                var productData = JSON.parse(jsonData);
                var isAvailable = productData.some(variant => variant.id == variantId);
    
                console.log('Variant ID:', variantId, 'is available:', isAvailable); // Debug: log variant availability
    
                if (isAvailable) {
                    $addon.find('.sbly-nl--quick-add-btn.btn-lbl').show();
                } else {
                    $addon.find('.sbly-nl--quick-add-btn.btn-lbl').hide();
                }
            } catch (error) {
                console.error('Error parsing JSON data for handle:', productHandle, error);
                $addon.find('.sbly-nl--quick-add-btn.btn-lbl').hide(); // Hide button if JSON parsing fails
            }
        } else {
            console.error('No data found for handle:', productHandle);
            $addon.find('.sbly-nl--quick-add-btn.btn-lbl').hide(); // Hide button if no data found
        }
    }

    $(document).on('change', 'select.product-variations', function() {
        var $selectedOption = $(this).find('option:selected');
        updateAddonValues($selectedOption);
    });

    // =========================================
    // AGREE AND DISAGREE BUTTONS
    // =========================================
    var userChoice = localStorage.getItem('userChoice');
    if (userChoice) {
        $('.sbly-nl--choice p').text('Thank you for your feedback!'); // Update the text if the choice has already been made
        $('.sbly-nl--choice-answer').hide(); // Hide the buttons if the choice has already been made
    } else {
        console.log('No user choice found');
    }

    $(document).on('click', '.sbly-nl--choice-answer', function(event) {
        event.preventDefault(); // Prevent the default anchor behavior

        // Get the data-answer attribute value
        var userChoice = $(this).data('answer');
        console.log('Saving user choice:', userChoice);

        // Save the user's choice in local storage
        localStorage.setItem('userChoice', userChoice);

        // Change the paragraph text to "Thank you for your feedback!"
        $('.sbly-nl--choice p').text('Thank you for your feedback!');

        // Hide the buttons after the user clicks
        $('.sbly-nl--choice-answer').hide();
    });
      
    // =========================================
    // POPUP LIGHTBOX
    // =========================================
    $(document).on('click', '.sbly-nl--popup', function(e) {
      e.preventDefault();
    
      var popupId = $(this).attr('id') + '-content';
      var content = $('#' + popupId).html();
    
      $('#popup-content').html(content);
      $('#popup-modal, #popup-overlay').fadeIn();
    });
  
    // Event handler for closing the popup
    $('#close-popup, #popup-overlay').on('click', function() {
      $('#popup-modal, #popup-overlay').fadeOut();
    });
  
    // =========================================
    // LIGHTGALLERY
    // =========================================
    lightGallery(document.getElementById('sbly-nl__animated-thumbnails'), {
      thumbnail: true,
      animateThumb: false,
      showThumbByDefault: true
    });
  
    $(document).on('click', '.sbly-nl--gallery-trigger a', function(event) {
      event.preventDefault();
      
      // Create a new LightGallery instance on the fly with the clicked image
      lightGallery(this, {
        dynamic: true,
        dynamicEl: [{
          src: $(this).attr('href'),
          thumb: $(this).find('img').attr('src'),
          subHtml: $(this).attr('data-alt')
        }]
      });
    });
  
    var $gallery = $('#sbly-nl__animated-thumbnails');
    var lgInstance = lightGallery($gallery[0], {
      thumbnail: true,
      animateThumb: false,
      showThumbByDefault: true
    });
  
    // Bind click events to the external links
    $('.sbly-nl--trigger-gallery').on('click', function (event) {
      event.preventDefault();
      var index = parseInt($(this).data('index'), 10);
      lgInstance.openGallery(index);
    });
  
    // =========================================
    // PRODUCT VARIATION: SIDEBAR WIDGET
    // =========================================
    var items = [];
    
    // Gather all product names and types dynamically
    $('.sbly-nl--module-item').each(function(){
      var productName = $(this).find('.product-name').text().trim();
      var productType = $(this).find('.product-type').text().trim();
      
      // Add productName as the subsequent items
      items.push({productType: productType, productName: productName});
    });
    
    // Function to create a new column
    function createNewColumn() {
      return $('<div class="sbly-nl--col" style="width: 50%;"><ul class="sbly-nl--ul-check sbly-nl--txt-xsmall"></ul></div>');
    }
    
    var $container = $('.sbly-nl--checkout-list');
    var $col = createNewColumn();
    var $ul = $col.find('ul');
    
    // Append items to columns dynamically
    items.forEach(function(item, index){
      var liClass = (index === 0) ? 'item-addon-check' : 'item-addon-plus';
      var $li = $('<li>', {
        class: liClass,
        text: item.productType,
        'data-product-type': item.productType
      });
      if (index > 0 && index % 4 === 0) {
        $container.append($col);
        $col = createNewColumn();
        $ul = $col.find('ul');
      }
      $ul.append($li);
    });
    
    $container.append($col); // Append the last column
    
    // =========================================
    // PRODUCT VARIANT: ADD BUTTON
    // =========================================
  
    // Function to update hidden input with selected addon variant IDs
    function updateAddonVariants() {
      var addonVariants = $('#addon-variants').val();
      if (addonVariants) {
        return addonVariants.split(',').filter(Boolean);
      }
      return [];
    }
  
    // Function to update the state of addon buttons based on the selected size variant
    function updateAddonButtons(selectedSize) {
        $('.sbly-nl-addon').each(function() {
            var $addon = $(this);
            var variantSize = $addon.find('.sbly-nl--quick-add-btn').data('variant-size');
  
            if (variantSize === selectedSize) {
                $addon.removeClass('sbly-nl--no-match-disable');
            } else {
                $addon.addClass('sbly-nl--no-match-disable');
                $addon.find('.sbly-nl--quick-add-btn').removeClass('btn-added');
            }
        });
  
        // Clear the hidden addon variants
        $('#addon-variants').val('');
    }
  
    // Function to update hidden input with selected addon variant IDs
    function updateAddonVariants() {
        var addonVariants = $('#addon-variants').val();
        if (addonVariants) {
            return addonVariants.split(',').filter(Boolean);
        }
        return [];
    }
    
    // Add this helper function to handle the case when addon variants are optional
    function getAddonVariants() {
      var addonVariants = $('#addon-variants').val();
      return addonVariants ? addonVariants.split(',').filter(Boolean) : [];
    }
  
    // Function to update the state of addon buttons based on the selected size variant
    function updateAddonButtons(selectedSize) {
        $('.sbly-nl-addon').each(function() {
            var $addon = $(this);
            var variantSize = $addon.find('.sbly-nl--quick-add-btn').data('variant-size');
  
            if (variantSize === selectedSize) {
                $addon.removeClass('sbly-nl--no-match-disable');
            } else {
                $addon.addClass('sbly-nl--no-match-disable');
                $addon.find('.sbly-nl--quick-add-btn').removeClass('btn-added');
            }
        });
  
        // Clear the hidden addon variants
        $('#addon-variants').val('');
    }
    
    $(document).on('click', '.sbly-nl--quick-add-btn', function() {
      var $button = $(this);
      var variantId = $button.data('variant-id');
      var isChecked = $button.hasClass('btn-added');
      var price = parseFloat($button.data('price'));
      var addonPrices = parseFloat($('#addon-prices').val()) || 0;
  
      var $checkIcon = $button.find('.action-check');
      var $addIcon = $button.find('.action-add');
      var $moduleItem = $button.closest('.sbly-nl--module-item');
      var productType = $moduleItem.find('.product-type').text().trim();
      var originalPrice = parseFloat($('#original-price').val()) || 0;
  
      if ($addIcon.is(':visible')) {
        $addIcon.addClass('fade-out').one('animationend', function() {
          $addIcon.removeClass('fade-out').hide();
          $checkIcon.show().addClass('fade-in').one('animationend', function() {
            $checkIcon.removeClass('fade-in');
          });
        });
        addonPrices += price; // Add the price
      } else {
        $checkIcon.addClass('fade-out').one('animationend', function() {
          $checkIcon.removeClass('fade-out').hide();
          $addIcon.show().addClass('fade-in').one('animationend', function() {
            $addIcon.removeClass('fade-in');
          });
        });
        addonPrices -= price; // Subtract the price
      }
  
      $('#addon-prices').val(addonPrices);
  
      if (isChecked) {
        var addonVariants = updateAddonVariants();
        addonVariants = addonVariants.filter(function(id) {
          return id != variantId;
        });
        $('#addon-variants').val(addonVariants.join(','));
      } else {
        var addonVariants = updateAddonVariants();
        addonVariants.push(variantId);
        $('#addon-variants').val(addonVariants.join(','));
      }
  
      $button.toggleClass('btn-added');
  
      if ($moduleItem.find('.btn-added').length > 0) {
        $moduleItem.addClass('sbly-nl--item-checked');
      } else {
        $moduleItem.removeClass('sbly-nl--item-checked');
      }
  
      $('.sbly-nl--checkout-list li').each(function() {
        if ($(this).attr('data-product-type') === productType) {
          if ($moduleItem.hasClass('sbly-nl--item-checked')) {
            $(this).removeClass('item-addon-plus').addClass('item-addon-check');
          } else {
            $(this).removeClass('item-addon-check').addClass('item-addon-plus');
          }
        }
      });
  
      var updatedPrice = originalPrice + addonPrices;
      updateCartPrice(updatedPrice); // Update the cart price with the new total
    });
  
    // =========================================
    // ADD TO CART
    // =========================================
  
    // Store the original text of the button
    $('#sbly-nl--add-to-cart').data('original-text', $('#sbly-nl--add-to-cart').text());
    const redirectToCartAfterAdd = $('body').data("cart-page-after-add");    
          
    $(document).on('click', '#sbly-nl--add-to-cart', function() {
      let $button = $(this);
      let originalText = $button.data('original-text');
    
      // Set loading text
      $button.text('Loading...');
    
      let selectedVariant;
      $('#sbly-nl--variant-form input[name="variant"]').each(function() {
        if ($(this).is(':checked')) {
          selectedVariant = $(this).val();
          return false; // Break the loop
        }
      });
    
      if (selectedVariant) {
        // Gather addon variants
        let addonVariants = getAddonVariants();
        let itemsToAdd = [{ id: selectedVariant, quantity: 1 }];
    
        if (addonVariants.length > 0) {
          addonVariants.forEach(function(variantId) {
            itemsToAdd.push({ id: variantId, quantity: 1 });
          });
        }
    
        console.log('Items to add:', itemsToAdd); // Debug log
    
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({ items: itemsToAdd }),
          success: function(data) {
            console.log('Added to cart:', data);
    
            // Set "Added to cart" text
            $button.text('Added to cart');
    
            // Dispatch the custom event to open the cart drawer (if the product does not specify to open the cart page)
            if (redirectToCartAfterAdd) {
              window.location.href = '/cart';
            } else {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: data,
                  addToCartBtn: document.getElementById('sbly-nl--add-to-cart')
                }
              }));
            }
    
            // After 2 seconds, revert the text back to the original
            setTimeout(function() {
              $button.text(originalText);
            }, 2000);
          },
          error: function(error) {
            console.error('Error adding to cart:', error);
            $button.text(originalText);
          }
        });
      } else {
        alert('Please select a variant.');
        $button.text(originalText);
      }
    });
  
    // Automatically select the first variant
    if ($('#sbly-nl--variant-form input[name="variant"]').length > 0) {
      $('#sbly-nl--variant-form input[name="variant"]').first().prop('checked', true);
    }
  
    // =========================================
    // JUDGEME TO SIDEBAR
    // =========================================
  
    // Clone the first .jdgm-widget content
    var clonedContent = $('.jdgm-widget').first().clone();
    
    // Insert <br/> before the .jdgm-prev-badge__text span
    clonedContent.find('.jdgm-prev-badge__text').before('<br/>');
    
    // Append the modified content to the .judgeme-small div
    $('.sbly-nl--judgeme-small').append(clonedContent);
  
    // =========================================
    // ADDONS DATA
    // =========================================
    // Fetch data for all products and dynamically append hidden divs
    const handlesString = $('#product_addon_data_handles').text().trim();
    const productHandles = handlesString.split(' | ').filter(handle => handle); // Ensure no empty handles are processed

    const fetchProductData = (handle, callback) => {
        console.log('Fetching data for product handle:', handle); // Debug: print handle
        $.ajax({
            url: `/products/${handle}.js`,
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                // Filter only available variants
                const availableVariants = data.variants.filter(variant => variant.available);
                const variantsData = JSON.stringify(availableVariants);
                $(`#${handle}_data`).text(variantsData); // Store only the available variations
                console.log('Available variants for handle:', handle, availableVariants); // Debug: print available variants
                if (callback) callback();
            },
            error: function(error) {
                console.error('Error fetching product data for handle:', handle, error);
            }
        });
    };

    productHandles.forEach(handle => {
        $('#product_addon_data_handles').after(`<div id="${handle}_data" style="display:none;"></div>`);
        fetchProductData(handle, () => {
            createDropdown(handle); // Create dropdown after data is fetched
        });
    });

    const updateButtonAttributes = (button, variant) => {
        $(button).attr('data-price', variant.price)
                 .attr('data-compare-at-price', variant.compare_at_price)
                 .attr('data-variant-id', variant.id)
                 .attr('data-variant-size', variant.title); // Assuming variant title is size
    };

    const handleSelectionChange = () => {
        const selectedSize = $('#size-selection').val(); // Assuming select input for size
        productHandles.forEach(handle => {
            const productData = JSON.parse($(`#${handle}_data`).text());
            const matchingVariant = productData.find(variant => variant.title === selectedSize);
            if (matchingVariant) {
                const buttons = $(`.sbly-nl--quick-add-btn[data-product-handle="${handle}"]`);
                buttons.each(function() {
                    updateButtonAttributes(this, matchingVariant);
                });
            }
        });
    };

    $('#size-selection').on('change', handleSelectionChange);

    const createDropdown = (handle) => {
        const jsonData = $(`#${handle}_data`).text().trim();
        if (jsonData) {
            try {
                const productData = JSON.parse(jsonData);
                let dropdownHtml = `<select class="product-variations product-variations-dropdown-data" id="${handle}-variations">`;
                productData.forEach(variant => {
                    if (variant.available) { // Check if the variant is available
                        dropdownHtml += `<option value="${variant.id}" data-price="${variant.price}" data-compare-at-price="${variant.compare_at_price}" data-variation="${variant.title}">${variant.title} - ${variant.price / 100}</option>`;
                    }
                });
                dropdownHtml += '</select>';
                $(`#${handle}_data`).after(dropdownHtml);
            } catch (error) {
                console.error('Error parsing JSON data for handle:', handle, error);
            }
        }
    };

    productHandles.forEach(handle => {
        createDropdown(handle);
    });

});
